import { useEffect } from 'react';
import { RouteObject, matchRoutes, useLocation } from 'react-router-dom';

export const APP_TITLE_SUFFIX = '50.Journeys';

type TitledRoute = RouteObject & {
  pageTitle?: string;
  commandPaletteName?: string;
};

type UseDocumentTitleProps = {
  routes: TitledRoute[];
  decoration?: string;
};

export const useDocumentTitle = ({ routes, decoration }: UseDocumentTitleProps) => {
  const location = useLocation();

  useEffect(() => {
    const matches = matchRoutes(routes, location.pathname);
    const route = matches?.[matches.length - 1]?.route;
    const section = route?.pageTitle ?? route?.commandPaletteName;
    const parts = [section, decoration, APP_TITLE_SUFFIX].filter(Boolean);
    document.title = parts.join(' · ');
  }, [location.pathname, decoration, routes]);
};
